/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { CheckboxProps } from 'ui';
import { FormControl, FormGroup, FormHelperText, FormLabel } from '@mui/material';
import { checkFormHasError, getFormHelperText } from 'ui/forms/formHelpers';
import {
  formGroupRoot,
  formHelperTextRoot,
  formLabelRoot,
} from 'ui/FormCheckboxGroup/formCheckboxGroupCssDefs';
import { useField } from 'formik';

export interface FormCheckboxGroupProps {
  label: React.ReactNode;
  helperText?: string;
  disabled?: boolean;
}

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const FormCheckboxGroup: React.FunctionComponent<
  React.PropsWithChildren<CheckboxProps & FormCheckboxGroupProps>
> = ({ helperText, label, disabled, children, className, ...rest }) => {
  const fieldAndMeta = useField(rest as any);

  const meta = fieldAndMeta[1];

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <FormControl className={className} error={hasError} component="fieldset" disabled={disabled}>
      <FormLabel css={formLabelRoot} component="legend">
        {label}
      </FormLabel>
      <FormGroup css={formGroupRoot}>
        {React.Children.map(children, (child) => {
          return React.cloneElement(child as any, { group: true });
        })}
      </FormGroup>
      {helperTextValue && (
        <FormHelperText css={formHelperTextRoot}>{helperTextValue}</FormHelperText>
      )}
    </FormControl>
  );
};

export default FormCheckboxGroup;
